export const TimeZoneOptions = [
  { value: "UTC", label: "UTC" },
  {
    value: "Dateline Standard Time",
    label: "(GMT-12:00) International Date Line West",
  },
  {
    value: "Samoa Standard Time",
    label: "(GMT -11:00) Mvalueway Island, Samoa",
  },
  { value: "Hawaiian Standard Time", label: "(GMT -10:00) Hawaii" },
  { value: "Alaskan Standard Time", label: "(GMT -09:00) Alaska" },
  {
    value: "Pacific Standard Time (Mexico)",
    label: "(GMT-08:00) Tijuana, Baja California",
  },
  {
    value: "Pacific Standard Time",
    label: "(GMT-08:00) Pacific Time (US & Canada)",
  },
  {
    value: "Mountain Standard Time",
    label: "(GMT-07:00) Mountain Time (US & Canada)",
  },
  {
    value: "Mountain Standard Time (Mexico)",
    label: "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
  },
  { value: "US Mountain Standard Time", label: "(GMT-07:00) Arizona" },
  {
    value: "Canada Central Standard Time",
    label: "(GMT-06:00) Saskatchewan",
  },
  {
    value: "Central Standard Time (Mexico)",
    label: "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
  },
  {
    value: "Central Standard Time",
    label: "(GMT-06:00) Central Time (US & Canada)",
  },
  {
    value: "Central America Standard Time",
    label: "(GMT-06:00) Central America",
  },
  {
    value: "US Eastern Standard Time",
    label: "(GMT-05:00) Indiana (East)",
  },
  {
    value: "Eastern Standard Time",
    label: "(GMT-05:00) Eastern Time (US & Canada)",
  },
  {
    value: "SA Pacific Standard Time",
    label: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
  },
  { value: "Venezuela Standard Time", label: "(GMT-04:30) Caracas" },
  { value: "Pacific SA Standard Time", label: "(GMT-04:00) Santiago" },
  { value: "Central Brazilian Standard Time", label: "(GMT-04:00) Manaus" },
  { value: "SA Western Standard Time", label: "(GMT-04:00) La Paz" },
  {
    value: "Atlantic Standard Time",
    label: "(GMT-04:00) Atlantic Time (Canada)",
  },
  {
    value: "Newfoundland Standard Time",
    label: "(GMT-03:30) Newfoundland",
  },
  {
    value: "Montevvalueeo Standard Time",
    label: "(GMT-03:00) Montevvalueeo",
  },
  { value: "Greenland Standard Time", label: "(GMT-03:00) Greenland" },
  { value: "SA Eastern Standard Time", label: "(GMT-03:00) Georgetown" },
  { value: "Argentina Standard Time", label: "(GMT-03:00) Buenos Aires" },
  {
    value: "E. South America Standard Time",
    label: "(GMT-03:00) Brasilia",
  },
  {
    value: "Mvalue-Atlantic Standard Time",
    label: "(GMT-02:00) Mvalue-Atlantic",
  },
  {
    value: "Cape Verde Standard Time",
    label: "(GMT-01:00) Cape Verde Is.",
  },
  { value: "Azores Standard Time", label: "(GMT-01:00) Azores" },
  { value: "Morocco Standard Time", label: "(GMT) Casablanca" },
  {
    value: "GMT Standard Time",
    label: "(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London",
  },
  { value: "Greenwich Standard Time", label: "(GMT) Monrovia, Reykjavik" },
  {
    value: "W. Europe Standard Time",
    label: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  },
  {
    value: "Central Europe Standard Time",
    label: "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  },
  {
    value: "Romance Standard Time",
    label: "(GMT+01:00) Brussels, Copenhagen, Madrvalue, Paris",
  },
  {
    value: "Central European Standard Time",
    label: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  },
  {
    value: "W. Central Africa Standard Time",
    label: "(GMT+01:00) West Central Africa",
  },
  { value: "Jordan Standard Time", label: "(GMT+02:00) Amman" },
  {
    value: "GTB Standard Time",
    label: "(GMT+02:00) Athens, Bucharest, Istanbul",
  },
  { value: "Mvaluedle East Standard Time", label: "(GMT+02:00) Beirut" },
  { value: "Egypt Standard Time", label: "(GMT+02:00) Cairo" },
  {
    value: "South Africa Standard Time",
    label: "(GMT+02:00) Harare, Pretoria",
  },
  {
    value: "FLE Standard Time",
    label: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  },
  { value: "Israel Standard Time", label: "(GMT+02:00) Jerusalem" },
  { value: "E. Europe Standard Time", label: "(GMT+02:00) Minsk" },
  { value: "Namibia Standard Time", label: "(GMT+02:00) Windhoek" },
  { value: "Arabic Standard Time", label: "(GMT+03:00) Baghdad" },
  { value: "Arab Standard Time", label: "(GMT+03:00) Kuwait, Riyadh" },
  {
    value: "Russian Standard Time",
    label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
  },
  { value: "E. Africa Standard Time", label: "(GMT+03:00) Nairobi" },
  { value: "Georgian Standard Time", label: "(GMT+03:00) Tbilisi" },
  { value: "Iran Standard Time", label: "(GMT+03:30) Te   hran" },
  {
    value: "Arabian Standard Time",
    label: "(GMT+04:00) Abu Dhabi, Muscat",
  },
  { value: "Azerbaijan Standard Time", label: "(GMT+04:00) Baku" },
  { value: "Mauritius Standard Time", label: "(GMT+04:00) Port Louis" },
  { value: "Caucasus Standard Time", label: "(GMT+04:00) Yerevan" },
  { value: "Afghanistan Standard Time", label: "(GMT+04:30) Kabul" },
  {
    value: "Ekaterinburg Standard Time",
    label: "(GMT+05:00) Ekaterinburg",
  },
  {
    value: "Pakistan Standard Time",
    label: "(GMT+05:00) Islamabad, Karachi",
  },
  { value: "West Asia Standard Time", label: "(GMT+05:00) Tashkent" },
  {
    value: "India Standard Time",
    label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
  },
  {
    value: "Sri Lanka Standard Time",
    label: "(GMT+05:30) Sri Jayawardenepura",
  },
  { value: "Nepal Standard Time", label: "(GMT+05:45) Kathmandu" },
  {
    value: "N. Central Asia Standard Time",
    label: "(GMT+06:00) Almaty, Novosibirsk",
  },
  {
    value: "Central Asia Standard Time",
    label: "(GMT+06:00) Astana, Dhaka",
  },
  { value: "Myanmar Standard Time", label: "(GMT+06:30) Yangon (Rangoon)" },
  {
    value: "SE Asia Standard Time",
    label: "(GMT+07:00) Bangkok, Hanoi, Jakarta",
  },
  { value: "North Asia Standard Time", label: "(GMT+07:00) Krasnoyarsk" },
  {
    value: "China Standard Time",
    label: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
  },
  {
    value: "North Asia East Standard Time",
    label: "(GMT+08:00) Irkutsk, Ulaan Bataar",
  },
  {
    value: "Singapore Standard Time",
    label: "(GMT+08:00) Kuala Lumpur, Singapore",
  },
  { value: "W. Australia Standard Time", label: "(GMT+08:00) Perth" },
  { value: "Taipei Standard Time", label: "(GMT+08:00) Taipei" },
  {
    value: "Tokyo Standard Time",
    label: "(GMT+09:00) Osaka, Sapporo, Tokyo",
  },
  { value: "Korea Standard Time", label: "(GMT+09:00) Seoul" },
  { value: "Yakutsk Standard Time", label: "(GMT+09:00) Yakutsk" },
  {
    value: "Cen. Australia Standard Time",
    label: "(GMT+09:30) Adelavaluee",
  },
  { value: "AUS Central Standard Time", label: "(GMT+09:30) Darwin" },
  { value: "E. Australia Standard Time", label: "(GMT+10:00) Brisbane" },
  {
    value: "AUS Eastern Standard Time",
    label: "(GMT+10:00) Canberra, Melbourne, Sydney",
  },
  {
    value: "West Pacific Standard Time",
    label: "(GMT+10:00) Guam, Port Moresby",
  },
  { value: "Tasmania Standard Time", label: "(GMT+10:00) Hobart" },
  { value: "Vladivostok Standard Time", label: "(GMT+10:00) Vladivostok" },
  {
    value: "Central Pacific Standard Time",
    label: "(GMT+11:00) Magadan, Solomon Is., New Caledonia",
  },
  {
    value: "New Zealand Standard Time",
    label: "(GMT+12:00) Auckland, Wellington",
  },
  {
    value: "Fiji Standard Time",
    label: "(GMT+12:00) Fiji, Kamchatka, Marshall Is.",
  },
  { value: "Tonga Standard Time", label: "(GMT+13:00) Nuku'alofa" },
];
